<template>
  <div
    v-if="profile && profile.id"
    class="edit-profile box">
    <h2 class="is-size-2">Edit My Profile</h2>
    <div
      class="form edit-form">
      <h4 class="is-size-4">{{ profile.name }}</h4>

      <div class="box">
        <div class="field">
          <label
            class="label"
            for="color">
            Favorite Color
            <a
              href="https://www.w3schools.com/cssref/css_colors.asp"
              class="help-link"
              target="_blank">?</a>
          </label>
          <div class="field is-grouped level">
            <input
              v-model="profile.prefs.color"
              type="text"
              class="form-text input" />&nbsp;
            <color-swatch :color="profile.prefs.color" />
          </div>
        </div>

        <div class="field">
          <label
            class="label"
            for="shoe-size">Shoe Size</label>
          <input
            v-model="profile.prefs['shoe-size']"
            type="number"
            class="form-text shoe-size input" />
        </div>

        <div class="field">
          <label
            class="label"
            for="shirt-size">Shirt Size</label>
          <input
            v-model="profile.prefs['shirt-size']"
            type="text"
            class="form-text shirt-size input" />
        </div>
      </div>

      <div class="field box">
        <label
          class="label"
          >Interests ({{ profile.prefs.interests.length }} of 5)</label>
        <div
          v-for="(interest, i) in profile.prefs.interests"
          :key="i"
          class="interest-row field is-grouped level">
          <input
            v-model="profile.prefs.interests[i]"
            class="form-text interest input" />
            &nbsp;
            <a
              v-if="!saving"
              href="#"
              class="delete is-medium"
              @click.prevent="removeInterest(i)"></a>
        </div>
        <a
          v-if="canAddInterest && !saving"
          href="#"
          class="add-interest"
          @click.prevent="addInterest">Add Interest</a>
      </div>
    </div>
    <hr>
    <div class="buttons">
      <button
        :disabled="!profile || !profile.id || saving"
        :class="{'is-loading': saving}"
        class="button is-primary"
        @click="updateProfile">Save</button>
      <router-link
        :to="'/'"
        :disabled="saving">Cancel</router-link>
    </div>
  </div>
  <progress
    v-else
    class="progress is-medium is-success"
    max="100"></progress>
</template>

<script>
import api from '@/services/api'
import ColorSwatch from '@/components/ColorSwatch'

export default {
  name: 'EditProfile',
  components: {
    ColorSwatch
  },
  data () {
    return {
      profile: {},
      saving: false
    }
  },
  computed: {
    canAddInterest () {
      const int = this.profile.prefs.interests
      if (int.length > 4) { return false }
      if (this.blanks) { return false }
      return true
    },
    blanks () {
      const int = this.profile.prefs.interests
      return int.findIndex(i => !i) > -1
    }
  },
  mounted () {
    api.get('/me').then(({ data }) => {
      if (!data.user.prefs.interests || !data.user.prefs.interests.length) {
        data.user.prefs.interests = ['']
      }
      this.profile = data.user
    })
  },
  methods: {
    removeInterest (i) {
      this.profile.prefs.interests.splice(i, 1)
    },
    addInterest () {
      this.profile.prefs.interests.push('')
    },
    updateProfile () {
      this.saving = true
      api.put('/me', { profile: this.profile })
        .then(() => {
          this.saving = false
          this.$router.push('/')
        })
        .catch(err => {
          window.alert(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-profile {
  input {
    min-width: 25%;
  }
}
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  font-size: 30px;
}
.interest-row {
  color: red;
  a {
    color: red;
  }
}
.add-interest {
  color: green;
  text-decoration: underline;
  font-weight: bold;
  display: block;
  margin-left: 5px;
}
button {
  font-size: 20px;
  margin-right: 20px;
}
.help-link {
  display: inline-block;
  width: 18px;
  height: 18px;
  font-size: 12px;
  margin: 0 5px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  background-color: red;
  color: white;
  transition: .3s all ease-in-out;
  &:hover {
    background-color: green;
  }
}
</style>
